<template>
  <div>
    <qx-card title="客户" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="100000"
      :inFast="Boolean(id)"
    />
  </div>
</template>

<script>
import {
  orderTimeDriverChangeDetail, // 获取详情
} from 'api/operate';
import ApproveBox from 'components/approveBox';
export default {
  components: {
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
  },
  data () {
    return {
      loading: false,
      detailData: {
        before: {
          label: '切换前信息',
          tableData: {
            title: [
              {
                prop: 'formerUserName',
                label: '原司机',
              },
              {
                prop: 'formerMileageStr',
                label: '仪表里程',
              },
              {
                prop: 'formerRemark',
                label: '备注说明',
              },
              {
                prop: 'createDate',
                label: '发起时间',
              },
              {
                prop: 'formerMileageFileUrl',
                label: '上传附件',
                type: 'img',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        after: {
          label: '接收信息',
          tableData: {
            title: [
              {
                prop: 'receiveUserName',
                label: '接收司机',
              },
              {
                prop: 'receiveMileageStr',
                label: '仪表里程',
              },
              {
                prop: 'affirmDate',
                label: '接收时间',
              },
              {
                prop: 'receiveRemark',
                label: '备注说明',
              },
              {
                prop: 'receiveMileageUrl',
                label: '上传附件',
                type: 'img',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        other: {
          label: '其他信息',
          tableData: {
            title: [
              {
                prop: 'originUserName',
                label: '发起人',
              },
              {
                prop: 'stateName',
                label: '切换状态',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    async getData () {
      if (this.$route.path !== '/manage/operate/order/deal/orderDetailTab/driver/detail' && !this.id) {
        return;
      }
      this.loading = true;
      const detailRes = await orderTimeDriverChangeDetail({
        switchId: this.id || this.$route.query.id,
      });
      this.loading = false;
      if (!detailRes.failed) {
        this.detailData.before.tableData.data = detailRes;
        this.detailData.after.tableData.data = detailRes;
        this.detailData.other.tableData.data = detailRes;
      }
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import "styles/config.scss";
.orderStatusBox{
  overflow: auto;
}
.orderInfoBox{
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title{
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,.time{
    color: #666;
    line-height: 16px;
  }
  .desc{
    padding-bottom: 12px;
  }
}
.box{
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel{
  background: $grey;
}
.itemLabel,.itemText{
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
